import { InsightOperator } from '@/shared/types/analytics';

export const OPERATOR_LABELS: Record<string, Record<InsightOperator, string>> = {
  boolean: {
    eq: 'filters.operators.boolean.eq',
    ne: 'filters.operators.boolean.ne',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
  string: {
    eq: 'filters.operators.string.eq',
    ne: 'filters.operators.string.ne',
    like: 'filters.operators.string.like',
    nlike: 'filters.operators.string.nlike',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
  email: {
    eq: 'filters.operators.string.eq',
    ne: 'filters.operators.string.ne',
    like: 'filters.operators.string.like',
    nlike: 'filters.operators.string.nlike',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
  phone_number: {
    eq: 'filters.operators.string.eq',
    ne: 'filters.operators.string.ne',
    like: 'filters.operators.string.like',
    nlike: 'filters.operators.string.nlike',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
  int: {
    eq: 'filters.operators.numeric.eq',
    ne: 'filters.operators.numeric.ne',
    gt: 'filters.operators.numeric.gt',
    lt: 'filters.operators.numeric.lt',
    gte: 'filters.operators.numeric.gte',
    lte: 'filters.operators.numeric.lte',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
  number: {
    eq: 'filters.operators.numeric.eq',
    ne: 'filters.operators.numeric.ne',
    gt: 'filters.operators.numeric.gt',
    lt: 'filters.operators.numeric.lt',
    gte: 'filters.operators.numeric.gte',
    lte: 'filters.operators.numeric.lte',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
  categorical: {
    in: 'filters.operators.categorical.in',
    nin: 'filters.operators.categorical.nin',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
  datetime: {
    eq: 'filters.operators.datetime.eq',
    ne: 'filters.operators.datetime.ne',
    lt: 'filters.operators.datetime.lt',
    gt: 'filters.operators.datetime.gt',
    lte: 'filters.operators.datetime.lte',
    gte: 'filters.operators.datetime.gte',
    between: 'filters.operators.datetime.between',
    exists: 'filters.operators.exists',
  } as Record<InsightOperator, string>,
};

export const DEFAULT_OPERATORS: Record<string, InsightOperator> = {
  boolean: 'eq',
  string: 'eq',
  email: 'eq',
  phone_number: 'eq',
  int: 'eq',
  number: 'eq',
  categorical: 'in',
  datetime: 'eq',
};
